import { render, staticRenderFns } from "./CardTabs.vue?vue&type=template&id=6cbf6ded&scoped=true&"
import script from "./CardTabs.vue?vue&type=script&lang=js&"
export * from "./CardTabs.vue?vue&type=script&lang=js&"
import style0 from "./CardTabs.vue?vue&type=style&index=0&lang=css&"
import style1 from "./CardTabs.vue?vue&type=style&index=1&id=6cbf6ded&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cbf6ded",
  null
  
)

export default component.exports